import type { SVGProps } from 'react'

interface RavenIconProps extends SVGProps<SVGSVGElement> {}

export function RavenIcon(props: RavenIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M396.15-255.39l-53.3 127.62q-4.51 11.08-16.14 15.89-11.63 4.8-22.79.34-11.15-4.46-16.11-16.11-4.96-11.66-.5-22.81l47.23-113.23q-103.69-23.39-169.12-105.73Q100-451.77 100-557.81v-155.65q0-60.45 43.05-103.49Q186.09-860 246.54-860q18.72 0 35.75 5.58 17.02 5.58 33.94 12.42l174.85 72.23q11.46 4.62 11.15 16.58-.31 11.96-12.15 16.58l-97 36.99v68.85L816-354q6.23 4.62 10.04 10.54 3.81 5.92 5.42 13.15l21.85 115.39q2.61 13.92-5.97 24.42-8.57 10.5-22.3 10.5h-11.31q-8.88 0-15.73-4.73t-10.69-12.19l-26.93-58.47h-212.3V-130q0 12.75-8.63 21.37-8.63 8.63-21.39 8.63-12.75 0-21.37-8.63-8.61-8.62-8.61-21.37v-125.39h-91.93zm-149.6-423.46q-14.7 0-24.66-9.94-9.97-9.95-9.97-24.66 0-14.7 9.95-24.66 9.95-9.97 24.66-9.97 14.7 0 24.66 9.95t9.96 24.66q0 14.7-9.94 24.66-9.95 9.96-24.66 9.96zm151.53 306.54zm3.84 56.93h363l-86.46-56.93H398.08q-35.62 0-65.98-14.5-30.36-14.5-51.56-40.5-13.39-15.54-23.85-39.08-10.46-23.53-10.46-45.46 0-12.75 8.63-21.37 8.62-8.63 21.37-8.63 11.41 0 19.78 7.7 8.37 7.69 10.22 18.61 3.08 35.69 29.31 59.46 26.23 23.77 62.54 23.77h187.69L333.08-597.54v-115.92q0-36.08-25.23-61.31Q282.62-800 246.54-800t-61.31 25.23Q160-749.54 160-713.46v155.77q0 100.96 70.56 171.63 70.56 70.68 171.36 70.68z" />
    </svg>
  )
}
